<template>
  <div class="progress-ring">
    <svg class="progress-ring__circle" viewBox="0 0 120 120">
      <!-- Background Circle -->
      <circle class="progress-ring__background" cx="60" cy="60" r="52"></circle>

      <!-- Progress Circles -->
      <circle
        v-for="(percentage, index) in circles"
        :key="index"
        class="progress-ring__progress"
        :class="`progress-ring__progress-${index}`"
        cx="60"
        cy="60"
        r="52"
        :style="percentage"
      ></circle>
    </svg>
    <div class="progress-ring__label">
      <slot name="label"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressRing",
  props: {
    percentages: {
      type: Array,
      default: () => [0, 0]
    }
  },
  computed: {
    circles() {
      let styles = []
      let old = 0
      for (let i = 0; i < this.percentages.length; i++) {
        let perc = this.percentages[i] + old
        let style = this.calculateProgressStyle(perc, 52)
        styles.push(style)
        old += this.percentages[i]
      }
      return styles.reverse()
    }
  },
  methods: {
    calculateProgressStyle(percentage, radius) {
      const circumference = 2 * Math.PI * radius
      const offset = circumference - (percentage / 100) * circumference

      return {
        '--final-offset': `${offset}px`, // Set the CSS variable dynamically
        strokeDasharray: `${circumference} ${circumference}`,
        strokeDashoffset: offset,
        animation: `progress-grow 1s ease-out forwards`
      };
    },
  },
};
</script>

